import { useMemo } from 'react';

import { parseVariables } from 'craft/containers/Actions/parseVariables';
import { useUserTraits } from 'craft/hooks/useUserTraits';

export interface VariableMatch {
  name: string;
  type: string;
  fallback?: string;
  matchesTrait?: boolean;
}

export const useTraitMatches = (href?: string) => {
  const { data: userTraits, loading } = useUserTraits();

  const traitMatches = useMemo(() => {
    if (!href) {
      return [];
    }
    return parseVariables(href).map((variable) => {
      if (variable.type !== 'user') {
        return variable as VariableMatch;
      }

      const matchesTrait = !loading
        ? userTraits?.find((trait) => trait.name === variable.name) !== undefined
        : undefined;

      return {
        ...variable,
        matchesTrait,
      } as VariableMatch;
    });
  }, [href, userTraits]);

  return traitMatches;
};
